// extracted by mini-css-extract-plugin
module.exports = {"list":"Menu_list__1UiNh","link":"Menu_link__tnn0B","current":"Menu_current__3mG5F"};